import {createActions, handleActions, combineActions} from 'redux-actions';
import {combineReducers} from 'redux';
import dayjs from 'dayjs';
import {uniqBy} from "../utils/helpers";


function createCommonReducer(listName, baseName, reducers, options = {}) {
  let upperListName = listName.toUpperCase();
  let upperBaseName = baseName.toUpperCase();
  let {grouper, keyExtractor} = options;

  if (!keyExtractor) {
    keyExtractor = (item) => item.id;
  }

  const defaultState = {
    hasUpdates: false,
    pending: null,
    refreshing: false,
    loadingMore: false,
    sections: [],
    list: [],
    context: null,
    next: null,
    loadingObjects: {},
    deleting: {},
    lastUpdate: new Date(0),
  };

  function groupList(list) {
    let sections = [];

    if (!grouper || !list) {
      return sections;
    }

    let _index = {};

    list.forEach(function (item) {
      let title = grouper(item);

      if (!_index[title]) {
        let newList = [];
        _index[title] = newList;
        sections.push({
          title,
          data: newList,
        })
      }

      item['_index'] = _index[title].length;
      _index[title].push(item);
    });

    return sections;
  }

  return handleActions(
      {
        'APP_BECOME_INACTIVE': (state) => ({
          ...state,
          refreshing: false,
          loadingMore: false,
          hasUpdates: false,
          pending: null,
        }),
        [`CLEAR_${upperListName}`]: (state, {payload}) => ({
          ...defaultState,
        }),
        [`FETCH_${upperListName}`]: (state, {payload}) => ({
          ...state,
          context: payload.context,
          refreshing: true,
          lastUpdate: new Date(),
        }),
        [`FETCH_${upperListName}_SUCCESSED`]: (state, {payload}) => ({
          ...state,
          refreshing: false,
          list: payload.results,
          sections: groupList(payload.results),
          next: payload.next,
          count: payload.count,
          can_merge: payload.can_merge,
          hasUpdates: false,
          pending: null,
        }),
        [`FETCH_${upperListName}_SILENT`]: (state, {payload}) => {
          console.log('check updates');
          let hasUpdates = false;

          if (payload.count > 0 && payload.count > state.count) {
            hasUpdates = true;

          } else if (payload.results.length > 0 && state.list.length >= payload.results.length) {

            for (let i = 0; i < payload.results.length; i++) {
              if (keyExtractor(payload.results[i]) !== keyExtractor(state.list[i])) {
                hasUpdates = true;
                console.log('different', i);
                break
              }
              // hasUpdates = keyExtractor(payload.results[0]) !== keyExtractor(state.list[0]);
            }
          }

          return {
            ...state,
            pending: payload,
            hasUpdates: hasUpdates,
          }
        },
        [`FETCH_${upperListName}_FAILED`]: (state) => ({
          ...state,
          refreshing: false,
        }),

        [`DELETE_${upperListName}`]: (state, {payload: {id}}) => ({
          ...state,
          deleting: {
            ...state.deleting,
            [id]: true,
          }
        }),
        [`DELETE_${upperListName}_SUCCESSED`]: (state, {payload: {id}}) => {
          let newDeleting = {...state.loadingObjects};
          delete newDeleting[id];
          return {
            ...state,
            list: state.list.filter(function (o) {
              return o.id !== id;
            }),
            loadingObjects: newDeleting,
          }
        },
        [`DELETE_${upperListName}_FAILED`]: (state, {payload: {id}}) => {
          let newDeleting = {...state.loadingObjects};
          delete newDeleting[id];
          return {
            ...state,
            loadingObjects: newDeleting,
          }
        },

        [`FREEZE_${upperListName}`]: (state, {payload: {id}}) => ({
          ...state,
          loadingObjects: {
            ...state.loadingObjects,
            [id]: true,
          }
        }),

        [`FETCH_MORE_${upperListName}`]: (state) => ({...state, loadingMore: true}),
        [`FETCH_MORE_${upperListName}_SUCCESSED`]: (state, {payload}) => {
          let list = uniqBy(state.list.concat(payload.results), keyExtractor);

          return {
            ...state,
            loadingMore: false,
            list: list,
            sections: groupList(list),
            next: payload.next,
          }
        },
        [`FETCH_MORE_${upperListName}_FAILED`]: (state, {payload}) => ({
          ...state,
          loadingMore: false,
        }),
        [`UPDATE_${upperBaseName}`]: (state, {payload}) => {
          let list = state.list;
          let index = list.findIndex(function(o){return o.id = payload.id});

          if (index !== -1) {
            let thread = list[index];

            list[index] = {
              ...thread,
              ...payload,
            }
          }

          return {
            ...state,
            list: [...list],
          }
        },
        ...reducers,
      },
      {...defaultState},
  );
}

const defaultObjectCommentsState = {
  object: null,
  refreshing: false,
  loadingMore: false,
  list: [],
  next: null,
};

const objectCommentsReducer = handleActions(
    {
      [`FETCH_OBJECTCOMMENTS`]: (state, {payload: {object}}) => ({
        ...state,
        object,
        refreshing: true,
        list: object === state.object ? state.list : [],
      }),
      [`FETCH_OBJECTCOMMENTS_SUCCESSED`]: (state, {payload}) => ({
        ...state,
        refreshing: false,
        list: payload.results,
        next: payload.next,
        count: payload.count,
      }),
      [`FETCH_OBJECTCOMMENTS_FAILED`]: (state) => ({
        ...state,
        refreshing: false,
      }),
      [`FETCH_MORE_OBJECTCOMMENTS`]: (state) => ({...state, loadingMore: true}),
      [`FETCH_MORE_OBJECTCOMMENTS_SUCCESSED`]: (state, {payload}) => ({
        ...state,
        loadingMore: false,
        list: uniqBy(state.list.concat(payload.results), 'id'),
        next: payload.next,
      }),
      [`FETCH_MORE_OBJECTCOMMENTS_FAILED`]: (state, {payload}) => ({
        ...state,
        loadingMore: false,
      }),
      [`FETCH_MORE_COMMENT_THREADS`]: (state, {payload: {thread}}) => ({
        ...state,
        list: state.list.map(function (comment) {
          if (comment.id === thread) {
            return {
              ...comment,
              threads: {
                ...comment.threads,
                loadingMore: true,
              }
            }
          }

          return comment;
        }),
      }),
      [`FETCH_MORE_COMMENT_THREADS_SUCCESSED`]: (state, {payload: {thread, data}}) => {
        let comment = state.list.find(function(o){return o.id === thread});

        if (!comment) {
          return state;
        }

        return ({
          ...state,
          list: state.list.map(function (comment) {
            if (comment.id === thread) {
              return {
                ...comment,
                threads: {
                  list: uniqBy(comment.threads.list.concat(data.results), 'id'),
                  next: data.next,
                  loadingMore: false,
                }
              }
            }

            return comment;
          }),
        })
      },
      [`FETCH_MORE_COMMENT_THREADS_FAILED`]: (state, {payload: {thread}}) => ({
        ...state,
        list: state.list.map(function (comment) {
          if (comment.id === thread) {
            return {
              ...comment,
              threads: {
                ...comment.threads,
                loadingMore: false,
              }
            }
          }

          return comment;
        }),
      }),
    },
    defaultObjectCommentsState,
);

let hotSearches = createCommonReducer('hotSearches', 'hot-search', {}, {
  grouper: function (thread) {
    return groupLabelOfDate(thread.create_at);
  }
})

let liveThreads = createCommonReducer('liveThreads', 'live-link', {
  [`FETCH_LIVETHREADS`]: (state, {payload}) => ({
    ...state,
    context: payload.context,
    refreshing: true,
    loadingMore: false,
    list: [],
    next: null,
    sections: [],
    lastUpdate: new Date(),
  }),
}, {
  grouper: function (thread) {
    let date = dayjs(thread.publish_at);
    let now = dayjs();
    return date.year() === now.year() ? date.format('MM/DD') : date.format('YYYY/MM/DD');
  }
})

const defaultLoadingPage = {
  loading: false,
}

const loadingPage = handleActions({
  'START_LOADING_PAGE': () => ({
    loading: true,
  }),
  'FINISH_LOADING_PAGE': () => ({
    loading: false,
  }),
}, defaultLoadingPage);


const defaultIndexBundle = {
  loading: false,
  dailyHotSearches: [],
};

const indexBundle = handleActions({
  'FETCH_INDEXBUNDLE': (state) => ({
    ...state,
    loading: true,
  }),
  'FETCH_INDEXBUNDLE_SUCCESSED': (state, {payload}) => ({
    ...state,
    dailyHotSearches: payload.dailyHotSearches,
    loading: false,
  }),
  'FETCH_INDEXBUNDLE_FAILED': (state) => ({
    ...state,
    loading: false,
  }),
}, defaultIndexBundle);


export default combineReducers({
  featuredRecords: createCommonReducer('featuredRecords', 'record'),
  latestRecords: createCommonReducer('latestRecords', 'record'),
  myPosts: createCommonReducer('myPosts', 'post'),
  myMoments: createCommonReducer('myMoments', 'moment'),
  myEvents: createCommonReducer('myEvents', 'post'),
  changeRequests: createCommonReducer('changeRequests', 'change-request'),
  objectChangeRequests: createCommonReducer('objectChangeRequests', 'change-request'),
  lives: createCommonReducer('lives', 'live'),
  updatedLives: createCommonReducer('updatedLives', 'live'),
  newLives: createCommonReducer('newLives', 'live'),
  headlineLives: createCommonReducer('headlineLives', 'live'),
  indexRecords: createCommonReducer('indexRecords', 'record'),
  events: createCommonReducer('events', 'event'),
  dailyHotSearches: createCommonReducer('dailyHotSearches', 'hot-search'),
  liveThreads: liveThreads,
  hotSearches: hotSearches,
  indexBundle,
  loadingPage,
});

